import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_TO_DEMO_END = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Find out more about Infosys Turf \nOptimization from our staff. ",
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  optionsButtons: [
    {
      label: "OVERVIEW",
      onClick: () => setCurrentPage(401),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage(405),
      type: "transparent",
      startIcon: "arrow-left",
    },
  ],
};

export default DATA_TO_DEMO_END;
